import { getAblyOnlyLog } from '../../../utils/getAblyOnlyLog/getAblyOnlyLog';
import {
  AtomicFooterType,
  type AtomicHeaderType,
  type AtomicItemListType,
} from '../getScreens/enums';
import type { IScreensComponent, ScreensReadModel } from '../getScreens/types';
import type { ScreensComponentResponse } from './getScreenComponent';

export const convertScreenComponent = (
  component: ScreensComponentResponse,
  screenLogging: ScreensReadModel['logging'],
): IScreensComponent => {
  return {
    componentId: component.component_id,
    type: {
      header: component.type.header as AtomicHeaderType,
      itemList: component.type.item_list as AtomicItemListType,
      footer: component.type.footer as AtomicFooterType,
    },
    logging: {
      analytics: {
        ...screenLogging,
        ...component.logging.analytics,
      },
      ably_only_log: {
        ...getAblyOnlyLog(component.logging),
      },
    },
    entity: {
      header: component.entity.header
        ? {
            item: component.entity.header.item,
            logging: {
              analytics: {
                ...screenLogging?.analytics,
                ...component.logging.analytics,
                ...component.entity.header.logging?.analytics,
              },
              ably_only_log: {
                ...getAblyOnlyLog(component.logging),
                ...getAblyOnlyLog(component.entity.header.logging),
              },
            },
          }
        : null,
      itemList: component.entity.item_list
        ? component.entity.item_list.map(item => {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const i: any = item;
            return i.item_entity != null
              ? {
                  type: i.type,
                  item: i.item_entity.item,
                  logging: {
                    analytics: {
                      ...screenLogging?.analytics,
                      ...component.logging?.analytics,
                      ...i.item_entity.logging?.analytics,
                    },
                    ably_only_log: {
                      ...getAblyOnlyLog(component.logging),
                      ...getAblyOnlyLog(i.item_entity.logging),
                    },
                  },
                  render: i.item_entity.render || null,
                }
              : {
                  item: i.item,
                  logging: {
                    analytics: {
                      ...screenLogging?.analytics,
                      ...component.logging?.analytics,
                      ...i.logging?.analytics,
                    },
                    ably_only_log: {
                      ...getAblyOnlyLog(component.logging),
                      ...getAblyOnlyLog(i.logging),
                    },
                  },
                  render: i.render || null,
                };
          })
        : null,
      footer: component.entity.footer
        ? {
            item: component.entity.footer.item,
            logging: {
              analytics: {
                ...screenLogging?.analytics,
                ...component.logging.analytics,
                ...component.entity.footer.logging.analytics,
              },
              ably_only_log: {
                ...getAblyOnlyLog(component.logging),
                ...getAblyOnlyLog(component.entity.footer.logging),
              },
            },
          }
        : null,
      body: component.entity.body ?? null,
    },
  };
};
